import Angular from "angular";
import Template from "./month-calendar.html";
import CalendarItem from "./calendar-item";
import Controller from "./month-calendar.controller";
import Workloads from "../../services/workload.service";
import IfScreenSize from "../../../core/directives/if-screen-size";

let MonthCalendarModule = Angular.module('month-calendar', [
    CalendarItem.name,
    Workloads.name,
    IfScreenSize.name])

    .component('monthCalendar', {
        template: Template,
        controller: Controller,
        transclude: {
            'calendarItemContent': '?calendarItemContent'
        },
        bindings: {
            calendar: "<",
            showItemColors: '<',
            onItemTap: "&"
        }
    });

export default MonthCalendarModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/month-calendar.js